/** "Link copied" confirmation for file links (web shell; native shows its own pasteboard HUD/snackbar). */
import { Toast, useT } from "@bundle/ui";
import { useEffect, useState } from "react";
import type { WebFilePlatform } from "../platform/files/actions.ts";

export function FilesToast({ files }: { files: WebFilePlatform }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  useEffect(() => files.onCopied(() => setOpen(true)), [files]);
  return <Toast open={open} onClose={() => setOpen(false)} message={t("files.linkCopied")} icon={{ name: "checkCircle", tone: "success" }} closeLabel={t("common.close")} durationMs={2500} testID="link-copied-toast" />;
}
